import React, { useEffect, useState } from "react";
import useStyles, {
  aboutDrawerWidth,
  aboutTogglebarWidth,
  chartTogglebarWidth,
  filterContainerHeight,
  chartTitleHeight,
} from "../Styles";
import { toolbarHeight, filterToolbarHeight } from "components/app/Styles";
import { Box, Tooltip, Slider, Typography, Grid } from "@material-ui/core";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import highChartsTilemap from "highcharts/modules/tilemap";
import addHeatmapModule from "highcharts/modules/heatmap";
import { getWindowSize } from "../utils";
import { useSelector } from "react-redux";
import userActions from "../actions";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";
// import { alias_entity_id_mapping } from "./polymap_constants";
import {
  positions,
  aliases,
  reverse_aliases,
  calculateLegendLabels,
  createSeries,
  findIndex,
} from "./polymap_constants";
import "rc-tooltip/assets/bootstrap_white.css";
import "../GaugePieChart/gaugePie.css";
import { sliderValues } from "../utils";

addHeatmapModule(Highcharts);
highChartsTilemap(Highcharts);
const startYear = 2024;
// const lastYear = 2028;
const inactiveTileOpacity = 0.2;
const activeTileOpacity = 1;
const activeTileShadowWidth = 3;

const valueLabelFormat = (value) => {
  // const num = value - startYear + 1;

  if (typeof value !== "number") {
    return value;
  }
  return value
};

const ValueLabelComponent = (props) => {
  const classes = useStyles();
  const { children, value } = props;
  const title = valueLabelFormat(value);

  return (
    <Tooltip
      placement="top"
      arrow
      title={title}
      open={true}
      classes={{
        tooltip: classes.technicalTooltipPopper,
      }}
    >
      {children}
    </Tooltip>
    // <RCTooltip
    //   placement="top"
    //   overlay={title}
    //   getTooltipContainer={() => document.querySelector(".MuiSlider-thumb")}
    //   visible={true}
    //   overlayClassName="rcTooltip"
    //   defaultVisible={true}
    // >
    //   {children}
    // </RCTooltip>
  );
};

const CitiesPolygonMap = () => {
  const classes = useStyles();
  const { isMobile } = useGetViewPortDimensions();
  const [windowSize, setWindowSize] = React.useState(getWindowSize());
  const {
    toggle_about,
    per_person_entitlement_difference,
    entitlements_by_year,
    entitlement_year,
    cities,
    scenario_selected,
  } = useSelector((state) => state.technical_view);
  const {
    setSelectedCity,
    loadEntityEntitlements,
    loadCityMetrics,
    loadCityWaterSources,
    setIsTribe,
    setIsWesternEntity,
    loadPerPersonEntitlementDifference,
    loadEntitlementsByYear,
    setEntitlementYear,
    alias_entity_id_mapping,
  } = userActions();
  const [options, setOptions] = useState(null);
  const [seriesInfo, setSeriesInfo] = useState([]);
  const [legendLabel, setlegendLabel] = useState([]);
  const defaultSliderYear = startYear;
  const [, setSelectedYear] = useState(defaultSliderYear);

  // const scale = (value) => {
  //   const previousMarkIndex = Math.floor(value / 25);
  //   const previousMark = marks[previousMarkIndex];

  //   const remainder = value % 25;
  //   if (remainder === 0 && previousMark !== undefined) {
  //     return previousMark.scaledValue;
  //   }
  // };

  /* 
  On any mouseover action (select/hover) on a honeycomb tile, 
  the right side charts and about section information are automatically updated
  */
  const displayDetailsOnTileSelect = (entity_name) => {
    /*
    We need to find cityID in order to load city metrics by calling backend APIs
    We first find the full city name (if any) from the colloquial name from reverse_alias map
    and then find the corresponsing cityID from the cities map
    */
    var aliased_city_name =  reverse_aliases.hasOwnProperty(entity_name)
                ? reverse_aliases[entity_name]
                : entity_name;
    var cityFound = cities.find((item) => item.label === (aliased_city_name));
    var cityIdx = cityFound["value"];
    loadCityMetrics(cityIdx);
    setSelectedCity(cityFound);
    loadEntityEntitlements(cityIdx, scenario_selected.value);
    loadCityWaterSources(cityIdx);
    setIsTribe(false);
    setIsWesternEntity(false);
  }

  const updateHoneycomb = () =>{
    const width = isMobile
      ? windowSize.innerWidth
      : windowSize.innerWidth -
        (toggle_about ? aboutDrawerWidth : aboutTogglebarWidth) -
        chartTogglebarWidth;
    const height = isMobile
      ? windowSize.innerHeight -
        toolbarHeight -
        filterToolbarHeight -
        chartTitleHeight -
        aboutTogglebarWidth
      : windowSize.innerHeight -
        toolbarHeight -
        chartTitleHeight -
        filterContainerHeight -
        5 - //leave space for slider
        130;
    // const dim = Math.min(width, height) - (isMobile ? 60 : 100);
    const dim = isMobile ? Math.min(width, height) - 30 : width/2  + +108;
    const optionsTemp = {
      chart: {
        type: "tilemap",
        animation: false,
        width: dim - (isMobile ? 10 : -100),
        height: dim - (isMobile ? 40 : 60),
        plotBackgroundColor: "transparent",
        backgroundColor: "transparent",
      },
      title: {
        text: "",
      },
      xAxis: {
        visible: false,
      },
      yAxis: {
        visible: false,
      },
      legend: {
        title: {
          text: isMobile
            ? "% Change Access of Water per Person"
            : "% Change </br> Access of Water </br> per Person",
          style: {
            fontStyle: "normal",
            fontSize: "12px",
          },
        },
        itemStyle: {
          color: "#333333",
          fontSize: "9px",
          fontWeight: "normal",
          fontFamily: "Arial",
        },
        labelFormatter: function () {
          return this.name + "%";
        },
        //   align: "center",
        backgroundColor: "#FFFFFF",
        borderColor: "#E0E0E0",
        borderWidth: 1,
        borderRadius: 15,
        //   width: "25%",
        //   padding: 10,
        itemMarginTop: 5,
        itemMarginBottom: 5,
        shadow: {
          offsetX: -1,
          offsetY: 3,
          color: "#00000029",
          width: 4,
        },
        align: "right",
        verticalAlign: "bottom",
        layout: "vertical",
        x: -100,
        y: -10,
        symbolRadius: 0,
        reversed: true,
        enabled: false,
      },
      tooltip: {
        //to prevent shorter screens from changing tooltip when the ouse is hovering over honeycombs behind it!
        // stickOnContact: true,
        enabled: false,
        outside: true,
        padding: 16,
        backgroundColor: "#FFF",
        borderRadius: 8,
        useHTML: true,
        style: {
          color: "#000",
          fontFamily: "'Arial', sans-serif",
          lineHeight: "0.5em",
        },
        formatter() {
          const name = this.point.real_name;
          let tooltip = "";
          if (alias_entity_id_mapping.hasOwnProperty(name)) {
            var entity_id = alias_entity_id_mapping[name];
            tooltip += "<p style='line-height:12px'><b>" + name + "</b></p>";
            tooltip += "<p>Year: <strong>" + entitlement_year + "</strong></p>";
            tooltip +=
              "<p>Colorado River access: <strong>" +
              (entitlements_by_year[entity_id]
                ? Math.round(
                    entitlements_by_year[entity_id].total_co_access
                  ).toLocaleString("en-US")
                : 0) +
              " ac-ft</strong></p>";
            tooltip +=
              "<p>P3: <strong>" +
              (entitlements_by_year[entity_id]
                ? Math.round(entitlements_by_year[entity_id].p3).toLocaleString(
                    "en-US"
                  )
                : 0) +
              " ac-ft</strong></p>";
            tooltip +=
              "<p>Indian: <strong>" +
              (entitlements_by_year[entity_id]
                ? Math.round(
                    entitlements_by_year[entity_id].indian
                  ).toLocaleString("en-US")
                : 0) +
              " ac-ft</strong></p>";
            tooltip +=
              "<p>M&I: <strong>" +
              (entitlements_by_year[entity_id]
                ? Math.round(entitlements_by_year[entity_id].mi).toLocaleString(
                    "en-US"
                  )
                : 0) +
              " ac-ft</strong></p>";
            tooltip +=
              "<p>NIA A: <strong>" +
              (entitlements_by_year[entity_id]
                ? Math.round(
                    entitlements_by_year[entity_id].nia_a
                  ).toLocaleString("en-US")
                : 0) +
              " ac-ft</strong></p>";
            tooltip +=
              "<p>NIA B: <strong>" +
              (entitlements_by_year[entity_id]
                ? Math.round(
                    entitlements_by_year[entity_id].nia_b
                  ).toLocaleString("en-US")
                : 0) +
              " ac-ft</strong></p>";
            tooltip +=
              "<p>DCP NIA: <strong>" +
              (entitlements_by_year[entity_id]
                ? Math.round(
                    entitlements_by_year[entity_id].dcp_nia
                  ).toLocaleString("en-US")
                : 0) +
              " ac-ft</strong></p>";
            tooltip +=
              "<p>Leases & Exchanges: <strong>" +
              (entitlements_by_year[entity_id]
                ? Math.round(
                    entitlements_by_year[entity_id].leases_exchanges
                  ).toLocaleString("en-US")
                : 0) +
              " ac-ft</strong></p>";
          }
          return tooltip;
        },
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        series: {
          animation: false,
          pointPadding: 2,
          dataLabels: {
            enabled: true,
            color: "#000000",
            format: "{point.name}",
          },
          states: {
            hover: {
              halo: false,
              enabled: false,
            },
          },
          point: {
            events: {
                mouseOver: function () {
                    var seriesData = this.series.data;
                    //looping through all the tiles in the hovered series
                    for (var i=0; i < seriesData.length; i++) {
                      // if a tile specifically is not hovered over, make it look inactive
                      if (i!==this.index) {
                        this.series.data[i].update({opacity: inactiveTileOpacity});
                        Highcharts.each(this.series.data[i].graphic.shadows, function(p) {
                          p.remove();
                        })
                      } 
                }          
                },
                mouseOut: function () {
                  var seriesData = this.series.data;
                  for (var i=0; i < seriesData.length; i++) {
                    // if a tile specifically was not hovered over, restore it's original active styling
                    if (i!==this.index) {
                      this.series.data[i].update({opacity: activeTileOpacity});
                      this.series.data[i].graphic.shadow({
                        width: activeTileShadowWidth,
                        opacity: activeTileOpacity
                      })
                    }
                      
                }

                },
                click: function () {
                  displayDetailsOnTileSelect(this.name);
                }
            }
        },
          shadow: true,
        },
      },
      series: [],
    };

    let series = createSeries(legendLabel);
    setSeriesInfo(series);

    if (
      Object.keys(per_person_entitlement_difference).length &&
      legendLabel.length
    ) {
      per_person_entitlement_difference["" + entitlement_year][
        "cityData"
      ].forEach((item) => {
        if (positions.hasOwnProperty(item.city_name)) {
          const idx =
            // selectedYear === defaultSliderYear
            //   ? 4
              // : 
              findIndex(item.percent_difference, legendLabel);

          if (typeof idx == "number") {
            series[idx].data.push({
              x: positions[item.city_name][0],
              y: positions[item.city_name][1],
              name: aliases.hasOwnProperty(item.city_name)
                ? aliases[item.city_name]
                : item.city_name,
              real_name: item.city_name,
            });
          }
        }
        // else if (item.city_name == "Arizona Water Co. (Pinal)") {
        //   const idx =
        //     selectedYear === 2022
        //       ? 4
        //       : findIndex(item.percent_difference, legendLabel);
        //   if (idx !== null) {
        //     series[idx].data.push({
        //       x: positions["Casa Grande"][0],
        //       y: positions["Casa Grande"][1],
        //       name: "Casa Grande",
        //       real_name: item.city_name,
        //     });
        //     series[idx].data.push({
        //       x: positions["Coolidge System"][0],
        //       y: positions["Coolidge System"][1],
        //       name: "Coolidge System",
        //       real_name: item.city_name,
        //     });
        //   }
        // }
      });
    }
    optionsTemp.series = series;
    setOptions(optionsTemp);
  }

  const handleSliderChange = (e, value) => {
    setEntitlementYear(value);
    // updateLegend()
  };

  const handleSliderChangeCommitted = (e, value) => {
    setSelectedYear(value);
    loadEntitlementsByYear(value, scenario_selected.value);
    updateLegend()
    updateHoneycomb()
  };

  const loadEntitlements = () => {
    loadEntitlementsByYear(entitlement_year, scenario_selected.value);
  }

  useEffect(loadEntitlements, [entitlement_year]);

  const componentUnMount = () => {
    // reset entitlements back to be used by map, which defaults at 2023
    return () => {
      loadEntitlementsByYear(defaultSliderYear, scenario_selected.value);
    };
  }
  useEffect(componentUnMount, []);

  const reSizeFunction = () => {
    loadPerPersonEntitlementDifference(scenario_selected.value);
    // setEntitlementYear(defaultSliderYear); We don't need this because the values are getting reset for other tabs.
    loadEntitlementsByYear(defaultSliderYear, scenario_selected.value);
    const handleWindowResize = () => {
      setWindowSize(getWindowSize());
    };
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }

  useEffect(reSizeFunction, []);

  const updateLegend = () =>{
    if (Object.keys(per_person_entitlement_difference).length) {
      let legend = calculateLegendLabels(
        per_person_entitlement_difference["max_difference"][entitlement_year],
        per_person_entitlement_difference["min_difference"][entitlement_year]
      );
      legend = legend.map((item) => {
        return Math.round(item);
      });
      setlegendLabel(legend);
    }
  }

  // update the legend labels when slider change or when we get the info for the entitlements
  useEffect(updateLegend, [per_person_entitlement_difference, entitlement_year]);

  const updateLegendAndHoneyComb = () => {
    updateLegend();
    updateHoneycomb()
  }
  useEffect(updateLegendAndHoneyComb, [
    windowSize,
    per_person_entitlement_difference,
    // legendLabel,
    // entitlements_by_year,
    isMobile,
    toggle_about,
  ]);

  const toggledPolyMapStyle = {
    width: `calc(100vw - ${aboutTogglebarWidth}px - ${chartTogglebarWidth}px)`,
  };

  return (
    // <Box className={classes.gaugePieContainer}>
    //   <Box className={classes.chartContainer}>
    //     <Grid
    //       className={classes.highchart}
    //       style={!isMobile ? { marginLeft: 220 } : null}
    //     >
    //       <HighchartsReact highcharts={Highcharts} options={options} />
    //     </Grid>
    //     <Grid className={classes.chartLegendContainer}>
    //       <Grid className={classes.chartLegend}>
    //         <Typography className={classes.legendTitle}>
    //           % Change Access {!isMobile && <br />} of Water per Person
    //         </Typography>
    //         <Box className={classes.legendItems}>
    //           {seriesInfo.length &&
    //             seriesInfo
    //               .map((series, idx) => {
    //                 return (
    //                   <Grid className={classes.legendItem} key={idx}>
    //                     <Box
    //                       classes={{ root: classes.legendItemColor }}
    //                       style={{ backgroundColor: series.color }}
    //                     />
    //                     <Typography className={classes.legendItemText}>
    //                       {series.name + "%"}
    //                     </Typography>
    //                   </Grid>
    //                 );
    //               })
    //               .reverse()}
    //         </Box>
    //       </Grid>
    //     </Grid>
    //   </Box>
    //   <Box className={classes.honeycombSliderContainer}>
    //     <Box className={classes.honeycombSlider}>
    //       <Slider
    //         value={entitlement_year}
    //         // scale={scale}
    //         marks={marks}
    //         min={2022}
    //         max={2026}
    //         defaultValue={defaultSliderYear}
    //         classes={{
    //           root: classes.citySlider,
    //           rail: classes.citySliderRail,
    //           trackInverted: classes.citySliderTrackInverted,
    //           track: classes.citySliderTrack,
    //           thumb: classes.citySliderThumb,
    //           mark: classes.citySliderMark,
    //           markLabel: classes.cityMarkLabel,
    //         }}
    //         onChange={handleSliderChange}
    //         valueLabelDisplay="on"
    //         getAriaValueText={valueLabelFormat}
    //         valueLabelFormat={valueLabelFormat}
    //         ValueLabelComponent={ValueLabelComponent}
    //       />
    //     </Box>
    //   </Box>
    // </Box>
    <>
      <Box
        className={classes.polymapContainer}
        style={toggle_about || isMobile ? null : toggledPolyMapStyle}
      >
        <Grid
          className={classes.highchart}
          style={!isMobile ? { marginTop: 140, marginBottom: 30 } : null}
        >
          <HighchartsReact highcharts={Highcharts} options={options} />
        </Grid>
      </Box>
      <Grid
        className={classes.chartLegendContainer}
        style={
          !isMobile
            ? { marginBottom: -70, marginRight: 16 }
            : { marginBottom: 20 }
        }
      >
        <Grid className={classes.chartLegend}>
          <Typography className={classes.polygonLegendTitle}>
            % Change Access {!isMobile && <br />} of Water per Person
          </Typography>
          <Box className={classes.legendItems}>
            {seriesInfo.length &&
              seriesInfo.map((series, idx) => {
                return (
                  <Grid className={classes.legendItem} key={idx}>
                    <Box
                      classes={{ root: classes.legendItemColor }}
                      style={{ backgroundColor: series.color }}
                    />
                    <Typography className={classes.polygonLegendItemText}>
                      {entitlement_year === 2024 ? "0%" : series.bucketRange}
                    </Typography>
                  </Grid>
                );
              })}
            {/* .reverse()} */}
          </Box>
        </Grid>
      </Grid>
      <Box className={classes.honeycombSliderContainer}>
        <Box
          className={classes.honeycombSlider}
          style={{ position: "relative", zIndex: 1, marginBottom: 40 }}
        >
          <Slider
            value={entitlement_year}
            min={sliderValues.min_value} // changes here
            max={sliderValues.max_value}
            marks={sliderValues.range}
            step={1}
            classes={{
              root: classes.citySlider,
              rail: classes.citySliderRail,
              trackInverted: classes.citySliderTrackInverted,
              track: classes.citySliderTrack,
              thumb: classes.citySliderThumb,
              mark: classes.citySliderMark,
              markLabel: classes.cityMarkLabel,
            }}
            onChange={handleSliderChange}
            onChangeCommitted={handleSliderChangeCommitted}
            valueLabelDisplay="on"
            getAriaValueText={valueLabelFormat}
            valueLabelFormat={valueLabelFormat}
            ValueLabelComponent={ValueLabelComponent}
          />
        </Box>
      </Box>
    </>
  );
};

export default CitiesPolygonMap;